
    var riot = require('riot')
    riot.tag2('checkout-summary', '<div class="show-xlarge"> <div id="sticker"> <div class="co-panel"> <h2>Summering</h2> <div class="co-content"> <div> <div class="co-table-left">Objekt</div> <div class="co-table-right">{model.itemPrice}&nbsp;kr</div> </div> <div> <div class="co-table-left">Fraktkostnad</div> <div class="co-table-right">{model.shippingCost}&nbsp;kr</div> </div> <div if="{model.discountAmount > 0}"> <div class="co-table-left">Rabatt</div> <div class="co-table-right co-discount">-&nbsp;{model.discountAmount}&nbsp;kr</div> </div> <div class="co-summary-divider"></div> <div class="co-summary-h1"> <div class="co-table-left">Att betala</div> <div class="co-table-right">{model.shippingCost + model.itemPrice - model.discountAmount}&nbsp;kr</div> </div> </div> </div> <div class="co-panel no-border"> <button class="primary-action {disabled-action:!isCheckoutValid}" onclick="{confirmButtonClick}">Betala</button> </div> </div> </div> <div class="hide-xlarge co-content"> <div class="co-summary-centered">Att betala</div> <div class="co-summary-centered co-summary-h1">{model.shippingCost + model.itemPrice - model.discountAmount} kr</div> <div class="co-summary-centered"><button class="primary-action {disabled-action:!isCheckoutValid}" onclick="{confirmButtonClick}">Betala</button></div> </div>', '', '', function(opts) {
        var $ = require('static/script/libs/jquery');
        this.context = require('static/script/app/ui/checkout2/context/context');

        this.model = opts.model;

        this.context.observable.on('shipping-changed', function (item) {
            this.model.shippingCost = item.shippingCost;
            this.model.shippingType = item.shippingType;
            this.update();
        }.bind(this));

        this.context.observable.on('payment-valid', function () {
            this.isCheckoutValid = true;
            this.update();
        }.bind(this));

        this.context.observable.on('payment-not-valid', function () {
            this.isCheckoutValid = false;
            this.update();
        }.bind(this));

        this.confirmButtonClick = function () {
            if (!this.isCheckoutValid) return;

            var model = {
                itemId: this.model.itemId,
                purchaseOrderId: this.model.purchaseOrderId,
                shippingType: this.model.shippingType,
                shippingCost: this.model.shippingCost
            };

            this.context.payment.performPayment(model, this.model.performPaymentUrl);
        }

        this.makeStickyDiv = function () {
            var s = $("#sticker");
            var pos = s.position();
            $(window).scroll(function () {
                var windowpos = $(window).scrollTop();
                if (windowpos >= pos.top) {
                    s.addClass("co-summary-stick");
                } else {
                    s.removeClass("co-summary-stick");
                }
            });
        }

        this.on('mount', function () {
            this.makeStickyDiv();
        });

});
    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/checkout-summary.riot.html